import { render, staticRenderFns } from "./WorkreportList.vue?vue&type=template&id=8dcd3038"
import script from "./WorkreportList.vue?vue&type=script&lang=js"
export * from "./WorkreportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports